var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isSettingsModalVisible)?_c('SettingsModal',{on:{"close":function($event){return _vm.INTRO_SET_SETTINGS_MODAL_VISIBLE(false)}}}):_vm._e(),(_vm.isAddPageVisible)?_c('AddPage',{on:{"close":function($event){return _vm.INTRO_SET_ADD_PAGE_VISIBLE(false)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }